<template>
  <div class="vip-club-badge" data-t="vip-club-badge">
    <span v-if="!simple" class="vip-progress">
      <span>{{ t('vip.myVipProgress') }}</span>
      <div>
        <span>{{ t('vip.nextLevel') }}: </span>
        <strong class="next-level"> {{ nextLevelTitle }} </strong>
      </div>
    </span>
    <div class="bottom-block">
      <img v-if="levelIcon" :src="levelIcon" class="level-icon" alt="icon" />
      <div class="level">
        <span class="level-title">{{ userLevelTitle }}</span>
        <span class="level-progress">{{ progressInCurrency }}</span>
      </div>
      <StButton class="button" size="m" type="ghost" to="/vip-club">
        {{ t('vip.vipClub') }}
      </StButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useVipClub } from '../../composables/useVipClub'

const { simple } = defineProps<{ simple?: boolean }>()

const { t } = useI18n()
const {
  userLevelTitle,
  nextLevelTitle,
  levelIcon,
  progressInCurrency,
  backgroundMobileColor,
} = useVipClub()
</script>

<style scoped>
.vip-club-badge {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-125);

  padding: var(--spacing-150);

  background-color: v-bind(backgroundMobileColor);
  border-radius: var(--border-radius-150);
}

.vip-progress {
  display: flex;
  justify-content: space-between;
  font: var(--mobile-caption-1-medium);
  color: var(--text-secondary);
}

.next-level {
  color: var(--text-primary);
  text-transform: capitalize;
}

.level-title {
  font: var(--mobile-headline-semibold);
  text-transform: capitalize;
}

.level-progress {
  font: var(--mobile-caption-1-regular);
}

.bottom-block {
  display: flex;
  gap: var(--spacing-100);
  align-items: center;
}

.level {
  display: flex;
  flex-direction: column;
}

.button {
  margin-left: auto;
}

.level-icon {
  width: 36px;
  height: 36px;
}
</style>
